<template>
    <PickForeground type="Stock Transfer"/>
</template>

<script>
import PickForeground from '@/views/pick/Foreground.vue';

export default {
    components:{
        PickForeground
    },
}
</script>